import { h, onMounted, ref, getCurrentInstance } from 'vue';
import $ from 'jquery';
import { useLegacyToastInterceptor } from '@apparatix/composables';
export default {
    props: {
        // eslint-disable-next-line vue/require-default-prop
        src: String,
        // eslint-disable-next-line vue/require-default-prop
        loadedCallback: Function,
        // eslint-disable-next-line vue/require-default-prop
        provideJquery: Boolean,
    },
    setup(props) {
        const iframeRef = ref(null);
        const { interceptInRealJquery } = useLegacyToastInterceptor(getCurrentInstance().appContext.app);
        const injectStyle = (doc, css) => {
            if (!doc)
                return;
            const head = doc.getElementsByTagName('head')[0];
            const styleEl = doc.createElement('style');
            head.appendChild(styleEl);
            styleEl.appendChild(doc.createTextNode(css));
        };
        const applyStylePatches = (doc) => {
            // This fixes the alignment of the dashboard left and right columns
            if (props.src === '/iframe-wrapper/landing/dashboard') {
                const dashboardCss = `
              body {
                background: #eee;
              }

              #c2 {
                top: 0 !important;
              }
          `;
                injectStyle(doc, dashboardCss);
            }
            // When running in an iframe, the overflow: hidden property on the body of the account page breaks scrolling
            if (props.src === '/iframe-wrapper/account') {
                const css = `
              body {
                overflow-y: auto !important;
              }
            `;
                injectStyle(doc, css);
            }
        };
        onMounted(() => {
            if (props.provideJquery) {
                iframeRef.value.contentWindow.$ = $;
            }
            const waitForFullLoad = () => {
                if (iframeRef.value.contentDocument?.readyState === 'complete') {
                    const cw = iframeRef.value.contentWindow;
                    if (cw.$) {
                        interceptInRealJquery(cw.$);
                    }
                    iframeRef.value.contentWindow.addEventListener('load', () => {
                        // This will only fire in chrome
                        applyStylePatches(iframeRef.value.contentDocument);
                        if (typeof props.loadedCallback === 'function') {
                            props.loadedCallback();
                        }
                    });
                    // This will only fire in firefox
                    applyStylePatches(iframeRef.value.contentDocument);
                    if (typeof props.loadedCallback === 'function') {
                        props.loadedCallback();
                    }
                    return; // Note the recursive call below, this line is necessary
                }
                setTimeout(() => waitForFullLoad(), 100);
            };
            waitForFullLoad();
        });
        return () => h('iframe', {
            src: props.src,
            ref: iframeRef,
            // sandbox: 'allow-scripts allow-same-origin allow-modals allow-popups allow-forms',
            referrerpolicy: 'same-origin',
        });
    },
};
